import { makeAutoObservable } from 'mobx';
import { RecoveryValidationError } from '../../../../../infrastructure/types/features/auth/auth-types';
import { validate } from '../../../../../../shared/logic/core-logic/validation/ValidationResult';
import { validationHelpers } from '../../../../../../shared/infrastructure/validation-rules/validation-helpers';
import { InvitationManager } from '../managers/InvitationManager';

class InvitationValidator {
  constructor(private invitationManager: InvitationManager) {
    makeAutoObservable(this, {});
  }

  get password() {
    const value = this.invitationManager.newPassword;

    return validate(
      validationHelpers.notUndefinedOrNull(value) &&
        validationHelpers.notEmptyString(value as string),
      RecoveryValidationError.PASSWORD_EMPTY,
    ).addCheckIfPreviousPassed(
      (value?.length || 0) >= 6,
      RecoveryValidationError.PASSWORD_INCORRECT,
    );
  }

  get passwordConfirmation() {
    const value = this.invitationManager.passwordConfirmation;
    const password = this.invitationManager.newPassword;

    return validate(
      validationHelpers.notUndefinedOrNull(value) &&
        validationHelpers.notEmptyString(value as string),
      RecoveryValidationError.PASSWORD_EMPTY,
    ).addCheckIfPreviousPassed(
      value === password,
      RecoveryValidationError.PASSWORD_CONFIRM_MISMATCH,
    );
  }

  get hasErrors() {
    return this.password.hasErrors || this.passwordConfirmation.hasErrors;
  }
}

export { InvitationValidator };
